module.exports = __webpack_public_path__ + "static/media/Childish Gambino - Me and Your Mama (Official Audio) (128 kbps).766cf6e1.mp3";